export const isObjectEmpty = <T extends Object>(obj: T) => {
  return Object.keys(obj).length === 0
}
